<template>
  <b-modal
    v-model="show"
    hide-footer
    centered
    size="md"
    dialog-class="premium-modal"
  >
    <div class="text-center p-4">
      <div class="icon-wrapper mb-3 mx-auto">
        <b-icon icon="lock-fill" variant="warning" font-scale="2" />
      </div>
      <h4 class="modal-title mb-2">{{ $t('academy.exclusive_access') }}</h4>
      <p class="modal-text mb-4">
        <i18n path="academy.premium_course_prompt" tag="span">
          <template #premium_status>
            <strong>{{ $t('academy.premium_status') }}</strong>
          </template>
        </i18n>
      </p>
      <div class="d-flex justify-content-center flex-column flex-sm-row gap-2">
        <b-button variant="primary" class="action-btn px-4" @click="contact">
         {{ $t('academy.contact_now') }} 
        </b-button>
        <b-button variant="outline-secondary" class="px-4" @click="show = false">
          Cerrar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      show: this.value
    };
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    contact() {
      window.open('mailto:inventech@gmail.com', '_blank');
    }
  }
};
</script>

<style scoped>
.premium-modal .modal-content {
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background-color: #fff8e1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-title {
  font-size: 1.4rem;
  font-weight: 600;
}

.modal-text {
  font-size: 1rem;
  color: #555;
}

.action-btn {
  font-weight: 600;
  transition: all 0.25s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

@media (min-width: 576px) {
  .gap-2 > * + * {
    margin-left: 0.75rem;
  }
}
</style>
